import React, { useContext } from 'react'
import Leaf from '../atoms/Leaf'
import DetailsPanelContext from '../../contexts/DetailsPanelContext'
import styled from 'styled-components'
import { APART_RELATIONSHIPS } from '../../assets/js/utils'

const NodeGroup = styled.g`
    cursor: pointer;
`

const NodeWrapper = styled.foreignObject`
    width: 104px;
    height: 120px;
    x: -52px;
    y: -60px;
    overflow: visible;
`

const PartnerGroup = styled.g`
    transform: translate(120px, 0);
`

const PartnerWrapper = styled.foreignObject`
    width: 104px;
    height: 120px;
    x: -52px;
    y: -60px;
    overflow: visible;
`

const LeafContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`

/**
 * Custom node component for react-d3-tree that renders Leaf components
 * Also renders partners horizontally next to the main node
 */
export const D3TreeLeafNode = ({
    nodeDatum,
    toggleNode,
    onNodeClick,
    onNodeDoubleClick,
}) => {
    const { panelState, setPanelState } = useContext(DetailsPanelContext)
    const leafId = nodeDatum.attributes?.leafId || nodeDatum.attributes?.id
    const name = nodeDatum.attributes?.display_name || nodeDatum.name
    const partners = nodeDatum.attributes?.partners || []

    const handleClick = (e, clickedLeafId, clickedName) => {
        e.stopPropagation()
        const nodeData = {
            ...nodeDatum,
            attributes: {
                ...nodeDatum.attributes,
                leafId: clickedLeafId,
                display_name: clickedName,
            },
        }
        if (onNodeClick) {
            onNodeClick(nodeData)
        }
    }

    const handleDoubleClick = (e, clickedLeafId, clickedName) => {
        e.stopPropagation()
        const nodeData = {
            ...nodeDatum,
            attributes: {
                ...nodeDatum.attributes,
                leafId: clickedLeafId,
                display_name: clickedName,
            },
        }
        if (onNodeDoubleClick) {
            onNodeDoubleClick(nodeData)
        }
    }

    return (
        <NodeGroup>
            {/* Main node */}
            <NodeWrapper>
                <LeafContainer
                    onClick={(e) => handleClick(e, leafId, name)}
                    onDoubleClick={(e) => handleDoubleClick(e, leafId, name)}
                >
                    <Leaf
                        leafId={leafId}
                        name={name}
                        toggleProfileModal={() => {}}
                    />
                </LeafContainer>
            </NodeWrapper>

            {/* Render partners horizontally */}
            {partners.map((partner, index) => {
                const partnerId = partner.id
                const partnerName = partner.display_name
                const isApart = APART_RELATIONSHIPS.includes(partner.relationship)
                const offsetX = 110 * (index + 1)

                return (
                    <PartnerGroup key={partnerId} style={{ transform: `translate(${offsetX}px, 0)` }}>
                        {/* Partner connection line - horizontal line from main node to partner */}
                        <line
                            x1={-offsetX + 44}
                            y1={0}
                            x2={-44}
                            y2={0}
                            stroke="var(--color_border_300)"
                            strokeWidth={2}
                            strokeDasharray={isApart ? '4 4' : '0'}
                        />
                        <PartnerWrapper>
                            <LeafContainer
                                onClick={(e) => handleClick(e, partnerId, partnerName)}
                                onDoubleClick={(e) =>
                                    handleDoubleClick(e, partnerId, partnerName)
                                }
                            >
                                <Leaf
                                    leafId={partnerId}
                                    name={partnerName}
                                    toggleProfileModal={() => {}}
                                />
                            </LeafContainer>
                        </PartnerWrapper>
                    </PartnerGroup>
                )
            })}
        </NodeGroup>
    )
}

export default D3TreeLeafNode
